import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LaunchDoctorPage } from './launch-doctor.page';

const routes: Routes = [
  {
    path: '',
    component: LaunchDoctorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LaunchDoctorPageRoutingModule {}
